import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center pt-[88px] pb-[100px] px-5" style={{
    background: 'linear-gradient(160deg, #0f2318 0%, #1a3a2a 60%, #1e4433 100%)'
  }} data-id="element-259">
      <div className="max-w-[1200px] w-full mx-auto flex flex-col items-center text-center mt-10" data-id="element-260">
        <p className="font-sans text-[11px] font-bold tracking-[0.3em] uppercase text-gold-accent mb-8" data-id="element-261">
          A PROSPERA EBOOK BY GODESKCORE · EST. 2025
        </p>

        <h1 className="font-serif text-[42px] md:text-[72px] text-white leading-[1.1] mb-4" data-id="element-262">
          <span className="block" data-id="element-263">You've Checked Your Balance</span>
          <span className="block" data-id="element-264">Three Times Tonight.</span>
          <span className="block italic text-gold-accent mt-2" data-id="element-265">
            It Doesn't Change.
          </span>
        </h1>

        <h2 className="font-serif text-[24px] md:text-[28px] italic text-cream-light mt-4 mb-6" data-id="element-266">
          That feeling has a name. And it ends tonight.
        </h2>

        <p className="font-sans text-[18px] text-white/75 max-w-[580px] leading-relaxed mb-10" data-id="element-267">
          The Debt-Free System is the complete 90-day field manual that
          eliminates your debt, ends the paycheck-to-paycheck cycle, and gives
          you back your Sunday nights — in 15 minutes a week.
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: 'easeOut'
      }} className="relative w-full max-w-[620px] mb-12" data-id="element-268">
          <div className="absolute inset-0 bg-gold-accent/10 blur-[60px] rounded-full scale-75 pointer-events-none" data-id="element-269" />
          <img src="https://cdn.magicpatterns.com/uploads/toJVxBMjgMPhvAE5KBmJyM/heylloyd-image-1774824865427.png" alt="The Debt-Free System — ebook and tablet mockup with worksheets, scripts, and tools spread on a desk" className="relative w-full h-auto rounded-lg shadow-[0_20px_60px_rgba(0,0,0,0.5)]" data-id="element-270" />
          <p className="mt-4 font-sans text-[12px] text-cream-light/40 italic" data-id="element-271">
            Digital PDF + all 19 tools · Works on any device
          </p>
        </motion.div>

        <CTAButton subText="Instant PDF download · Start in 5 minutes · Chapter 5 guarantee" className="mb-10" data-id="element-272">
          YES — SHOW ME THE SYSTEM → $9.99
        </CTAButton>

        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-[60px] mt-4 mb-8" data-id="element-273">
          <div className="flex flex-col items-center" data-id="element-274">
            <span className="font-serif text-[52px] text-gold-accent leading-none" data-id="element-275">
              19
            </span>
            <span className="font-sans text-[12px] uppercase tracking-wider text-cream-light/70 mt-2" data-id="element-276">
              Ready-to-Use Tools
            </span>
          </div>
          <div className="hidden md:block w-px h-16 bg-gold-accent/20" data-id="element-277"></div>
          <div className="flex flex-col items-center" data-id="element-278">
            <span className="font-serif text-[52px] text-gold-accent leading-none" data-id="element-279">
              7
            </span>
            <span className="font-sans text-[12px] uppercase tracking-wider text-cream-light/70 mt-2" data-id="element-280">
              Word-for-Word Scripts
            </span>
          </div>
          <div className="hidden md:block w-px h-16 bg-gold-accent/20" data-id="element-281"></div>
          <div className="flex flex-col items-center" data-id="element-282">
            <span className="font-serif text-[52px] text-gold-accent leading-none" data-id="element-283">
              84%
            </span>
            <span className="font-sans text-[12px] uppercase tracking-wider text-cream-light/70 mt-2" data-id="element-284">
              Success Rate — First Call
            </span>
          </div>
        </div>

        <p className="font-sans text-[12px] text-white/50 mt-6 mb-16" data-id="element-285">
          🔒 Secure Checkout · 📥 Instant Delivery · 💰 30-Second Refund Policy
        </p>

        <div className="absolute bottom-10 flex flex-col items-center" data-id="element-286">
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'easeInOut'
        }} className="text-gold-accent text-2xl mb-2" data-id="element-287">
            ↓
          </motion.div>
          <span className="font-sans text-[11px] text-white/50 uppercase tracking-widest" data-id="element-288">
            Scroll to see what's inside
          </span>
        </div>
      </div>
    </section>;
}